import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcreLogoWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M40.603 0H26.9666L3.09089e-05 45.8814H13.6365L40.603 0Z",
		fill: "#ffffff"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M34.5131 28.2274C34.5128 28.2019 34.5126 28.1764 34.5126 28.1509C34.5126 28.1253 34.5128 28.0998 34.5131 28.0743V28.0737H34.5131C34.5544 24.7999 37.2212 22.1587 40.5048 22.1587C43.7884 22.1587 46.4551 24.7999 46.4965 28.0737H46.4974V45.8167H34.5131V28.2274Z",
		fill: "#ffffff"
	})]
});
export default SvgAcreLogoWhite;
